<template>
  <tbody id="daysTable">
    <tr>
      <th class="botTableHeader date" rowspan="2">날짜</th>
      <th class="botTableHeader" colspan="4">합계</th>
    </tr>
    <tr>
      <th class="botTableHeader" v-for="(head, n) in headers" :key="tab + '_' + n">{{head}}</th>
    </tr>
    <template v-for="(dataDays, index) in daysData">
      <tr :key="tab + '_' + index" :class="[checkSubLenth(dataDays) ? '_isExist' : '_notExist']">
        <td @click="clickHandler(dataDays)" class="_dateWrap">
          <v-icon class="icon" v-if="!isExcel && checkSubLenth(dataDays)">
            {{checkDate(dataDays.ymd) ? up : down}}
          </v-icon>
          <div class="date_text">{{dataDays.ymd}}</div>
        </td>
        <td class="dataTd">
          <div class="bot_dataWrap">
            {{parseDataType(dataDays.imp)}}
          </div>
        </td>
        <td class="dataTd">
          <div class="bot_dataWrap">
            {{parseDataType(dataDays.click)}}
          </div>
        </td>
        <td class="dataTd">
          <div class="bot_dataWrap">
            {{dataDays.ctr === 0 ? 0 : dataDays.ctr.toFixed(2)}}
          </div>
        </td>
        <td class="dataTd" v-if="tab === 'contract' || tab === 'creativeGroup'">
          <div class="bot_dataWrap">
           {{parseDataType(dataDays.budget_amt)}}
          </div>
        </td>
      </tr>
      <template v-if="checkSubList(dataDays)">
        <tr v-for="(info, n) in dataDays.data" :key="tab + '_' + index + '_' + n" class="subRow">
          <td :class="[isCreative ? '_creative' : '']">
            <div class="subText">
              {{isSizeAndeExcel() ? subListName(info) + ' ' + info.ad_knd_nm : subListName(info)}}
            </div>
          </td>
          <td class="dataTd" :key="tab + '_' + n">
            <div class="bot_dataWrap">
              {{parseDataType(info.imp_cnt)}}
            </div>
          </td>
          <td class="dataTd" :key="tab + '_' + n">
            <div class="bot_dataWrap">
              {{parseDataType(info.click_cnt)}}
            </div>
          </td>
          <td class="dataTd" :key="tab + '_' + n">
            <div class="bot_dataWrap">
              {{info.ctr === 0 ? 0 : info.ctr.toFixed(2)}}
            </div>
          </td>
          <td class="dataTd" :key="tab + '_' + n" v-if="tab === 'contract' || tab === 'creativeGroup'">
            <div class="bot_dataWrap">
              {{parseDataType(info.budget_amt)}}
            </div>
          </td>
        </tr>
      </template>
    </template>
  </tbody>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {parseDataType, subListName} from '@/assets/func'

  export default {
    name: 'daysImp',
    data () {
      return {
        down: 'keyboard_arrow_down',
        up: 'keyboard_arrow_up',
        isInter: false
      }
    },
    props: {
      // data props
      headers: Array,
      isCreative: Boolean,
      isExcel: Boolean,
      tab: String,
      // function props
      checkDate: Function,
      clickDate: Function
    },
    methods: {
      parseDataType (str) {
        return parseDataType(str)
      },
      checkSubList (dataDays) {
        let a = this.checkDate(dataDays.ymd)
        let b = this.checkSubLenth(dataDays)
        // if (this.isExcel) a = true
        return a && b
      },
      isSizeAndeExcel () {
        return (this.tab === 'size' || this.tab === 'geo')// && this.isExcel
      },
      clickHandler (dataDays) {
       // if (this.isExcel) return
        if (!this.checkSubLenth(dataDays)) return
        this.clickDate(dataDays.ymd)
      },
      checkSubLenth (dataDays) {
        if (dataDays.ymd === '') return false
        switch (this.tab) {
          case 'size': // size는 ymd아닌 ad_knd_nm
            return dataDays.data[0].size_nm !== null
          case 'creative':
            return dataDays.data[0].creative_nm !== null
          case 'creativeGroup':
            return dataDays.data[0].group_nm !== null
          case 'contract':
            return dataDays.data[0].ad_knd_nm !== null
          case 'geo':
            return dataDays.data[0].geo_nm !== null
        }
      },
      subListName (info) {
        return subListName(info, this.tab)
      }
    },
    computed: {
      ...mapGetters([
        'daysImpData'
      ]),
      daysData () {
        // return this.daysImpData(this.tab, this.isExcel)
        return this.daysImpData(this.tab, false)
      }
    }
  }
</script>

<style scoped>
  ._notExist {
    background: rgb(247, 249, 250);
  }
  .subRow {
    background: rgb(242, 243, 245);
  }
  .icon {
    vertical-align: middle;
    color: #689f38;
    font-weight: bold;
  }
  span {
    vertical-align: middle;
  }
  .subText {
    margin-left: 30px;
    text-align: left;
  }
  ._creative {
    text-align: left;
    min-width: 170px;
    max-width: 170px;
  }
  ._dateWrap {
    text-align: left;
    padding-left: 30px;
    min-width: 120px;
    max-width: 120px;
  }
  ._isExist ._dateWrap:hover {
    cursor: pointer;
  }
  ._dateWrap .icon {
    position: absolute;
    left: 10px;
  }
  ._creative .subText {
    margin-left: 0 !important;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 5px;
  }
  .date_text {
    display: inline-block;
  }
  tbody tr:first-child th:first-child {
    border-right: none;
  }
  th, td {
    height: 25px;
  }
  td {
    border-bottom: 1px solid #eaeaea
  }
  tbody tr:last-child td {
    border-bottom: none;
  }

  @media screen and (max-width: 600px) {
    ._creative .subText {
      padding-left: 5px;
    }

    .icon {
      margin-left: -5px;
    }
    ._creative .icon {
      margin-left: 4px;
    }
    .botTableHeader.date {
      width: 15px;
    }
  }
  @media screen and (max-width: 350px) {
    ._creative {
      min-width: 155px;
      max-width: 155px;
    }
  }
</style>



// WEBPACK FOOTER //
// DaysImp.vue?4f21397b